const PARENT_CATEGORY_LINK_MAP = {
  Reviews: { link: '/guides', translationKey: 'article.viewAllReviews' },
  NewsAndAnalysis: {
    link: '/news-and-analysis',
    translationKey: 'article.viewAllNewsStories',
  },
  Guides: { link: '/guides', translationKey: 'article.viewAllGuides' },
};

export default class ParentCategory {
  constructor(parentCategory) {
    this.parentCategory = parentCategory;
  }

  get link() {
    if (PARENT_CATEGORY_LINK_MAP[this.parentCategory]) {
      return PARENT_CATEGORY_LINK_MAP[this.parentCategory].link;
    }
    return '/guides';
  }

  get translationKey() {
    if (PARENT_CATEGORY_LINK_MAP[this.parentCategory]) {
      return PARENT_CATEGORY_LINK_MAP[this.parentCategory].translationKey;
    }
    return 'article.viewAllGuides';
  }
}
